/**
 * Build and trigger download of a CSV file in the browser.
 * @param {Object} options
 * @param {string[]} options.headers - Column headers
 * @param {Array<Array<string|number|null|undefined>>} options.rows - Row cell values
 * @param {string} options.fileName - Download file name
 * @returns {number} Number of data rows exported
 */
export const downloadCsvFile = ({ headers, rows, fileName }) => {
  const csvRows = [headers.join(',')];

  rows.forEach((row) => {
    const escaped = row.map((cell) => `"${String(cell ?? '').replace(/"/g, '""')}"`);
    csvRows.push(escaped.join(','));
  });

  const csvContent = csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  return rows.length;
};
